import { useAuth0 } from 'app/Auth'
import axios from 'axios'
import { useMutation } from 'react-query'
import { LaborCostActionResponse, UpdateLaborCostParams } from '../types'

export const useUpdateLaborCost = () => {
  const { getAccessToken } = useAuth0()
  const LABOR_COST_URL = process.env.REACT_APP_REPORTS_URL

  return useMutation<LaborCostActionResponse, Error, UpdateLaborCostParams>(
    async (data: UpdateLaborCostParams) => {
      const token = await getAccessToken()
      try {
        const response = await axios.put(
          `${LABOR_COST_URL}api/v1/labor_cost/${data.id}`,
          data,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        )
        return response.data
      } catch (error) {
        throw error
      }
    }
  )
}
